// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__CQlt9","range":"MonthRangeSwitch_range__3w1ZV","disabled":"MonthRangeSwitch_disabled__30iD8"};